import debounce from 'lodash/debounce';
import React, { useLayoutEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';

const ListView = ({ children, className, onReachBottom }) => {
  const containerRef = useRef();
  const reachBottom = debounce(onReachBottom, 200);

  const scrollContainerRef = useRef();
  const scrollTopRef = useRef(0);

  useLayoutEffect(() => {
    scrollContainerRef.current = document.getElementById('root');
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;
    const scorllTop = document.scrollingElement.scrollTop;
    const client = document.scrollingElement.clientHeight;
    const bodyHeight = scrollContainer.clientHeight;
    if (!scorllTop || !client || !bodyHeight) {
      return;
    }
    if (scrollTopRef.current > scorllTop) {
      scrollTopRef.current = scorllTop;
      return;
    }
    if (scorllTop + client + 30 > bodyHeight) {
      reachBottom();
    }
    scrollTopRef.current = scorllTop;
  }, []);

  return (
    <Container className={className} onScroll={handleScroll} ref={containerRef}>
      {children}
    </Container>
  );
};

export default React.memo(ListView);

const Container = styled.div``;
